import {
  MODES,
  TABS,
  COMMON_SECTION_IDS,
  GUIDE_SECTION_IDS,
  VERSIONING_SECTION_IDS,
} from './constants';

export type SubsectionId =
  | COMMON_SECTION_IDS
  | GUIDE_SECTION_IDS
  | VERSIONING_SECTION_IDS;

export type PropertiesType = {
  mode?: MODES;
  tabActive: TABS;
  activeSubsection?: SubsectionId;
  sectionContext?: Record<string, any>;
};

export enum PromotionStepName {
  rebuildAllowlist = 'rebuild_allowlist',
  migrateZts = 'migrate_zts',
}

export enum MigrationStepName {
  addCustomusers = 'add_customusers',
  migrateZaps = 'migrate_zaps',
}
